<template>
  <div class="tabs_box">
    <el-tabs type="card" tab-position="top" >
        <el-tab-pane label="模具工艺">
          <wj-mold></wj-mold>
        </el-tab-pane>
        <el-tab-pane label="配件工艺">
          <wj-fittings></wj-fittings>
        </el-tab-pane>
        <el-tab-pane label="产品装配工艺">
          <wj-assembly></wj-assembly>
        </el-tab-pane>
        <el-tab-pane label="产品组装工艺">
          <wj-assemble></wj-assemble>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>

import wjAssemble from './assemble/index'
import wjAssembly from './assembly/index'
import wjFittings from './fittings/index'
import wjMold from './mold/index'


export default {
  name: 'solutions',
  components: {
    wjAssemble,
    wjAssembly,
    wjFittings,
    wjMold
  }

};
</script>

<style lang="scss" scoped>
 
  .el-tabs{
    margin: 18px;
  }
  // /deep/ .el-tabs--top{
  //   height: 680px !important;
  // }

  // .table_bottom{
  //   margin-bottom: 18px;
  // }
</style>